import React, { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents } from '@constants/index';
import { Analytics } from '@services/analytics-service';
import { useRouter, ROUTES } from '../../providers/router';
import { SelectionList } from '../../components/selection-list';
import { Levels } from '../../constants';

export const SubCategories = () => {
  useEffect(() => {
    Analytics.trackEvent(AnalyticEvents.sarSubCategoryViewed);
    datadogRum.addAction(AnalyticEvents.sarSubCategoryViewed);
  }, []);

  const { completeFormStep } = useRouter();

  const handleNextRoute = (dataSubset: any) => {
    completeFormStep(ROUTES.SUB_CATEGORIES, dataSubset);
  };

  return <SelectionList level={Levels.Subcategory} handleNextRoute={handleNextRoute} />;
};

export default SubCategories;
